import React from 'react';
import classNames from 'classnames';
import { IconAndText } from 'components/shared/SvgAF/SvgAF';
import { IconLoader } from 'common/IconLoader';
import { VERSION_MANAGER_OPTIONS } from 'pages/AdminPage/utils';
import styles from './VersionManagerTileHeader.module.css';

const VersionManagerTileHeader = ({
  selected,
  handleSelectionOnClick,
  fileInputRef,
  handleFileUploadOnChange,
  handleFileUploadOnClick,
  uploadSWPermissions
}) => (
  <div className={styles.root}>
    <div className={styles.header}>Version Manager</div>
    <div className={styles.control}>
      <div className={styles.titleContainer}>
        <div
          className={classNames({
            [styles.title]: true,
            [styles.titleSelected]: selected === VERSION_MANAGER_OPTIONS.SOFTWARE
          })}
          onClick={() => handleSelectionOnClick(VERSION_MANAGER_OPTIONS.SOFTWARE)}
        >
          Software
        </div>
        <div
          className={classNames({
            [styles.title]: true,
            [styles.titleSelected]: selected === VERSION_MANAGER_OPTIONS.BEAM_TABLES
          })}
          onClick={() => handleSelectionOnClick(VERSION_MANAGER_OPTIONS.BEAM_TABLES)}
        >
          Beam Tables
        </div>
      </div>
      <div className={styles.buttonDiv}>
        <input
          ref={fileInputRef}
          type="file"
          accept=".swdl"
          style={{ width: '0px', height: '0px', opacity: '0' }}
          onChange={(evt) => handleFileUploadOnChange(evt)}
        />
        {uploadSWPermissions && (
          <button
            className={classNames({
              [styles.addVersionBtn]: true,
              Global_ThinBlueButton: true,
            })}
            onClick={handleFileUploadOnClick}
          >
            <IconAndText
              img={IconLoader.icon_add_16}
              hoverImg={IconLoader.icon_add_16_hover}
              text={selected === VERSION_MANAGER_OPTIONS.SOFTWARE ? 'Add new version' : 'Add new beam table'}
            />
          </button>
        )}
      </div>
    </div>
  </div>
);

export default VersionManagerTileHeader;
